import '../App.css';

import { Button } from '../components/ui/button';

import { useNavigate } from 'react-router';

function NoMatch() {
    const navigate = useNavigate();
    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-24 gap-3 items-center'>
                <h1 className='text-6xl font-medium'>404</h1>
                <p>Sidan du begärde gick inte att hitta, eller så har länken du fått gått sönder.</p>
                <Button className='w-1/4' onClick={() => navigate('/')}>Gå tillbaka till start</Button>
            </div>
        </div>
    );
}

export default NoMatch;
